import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção Consultoria em TI — valores numéricos por moeda e ciclo. */

export const IT_CONSULTING_PLAN_PRICES = {
  start: {
    monthly: { BRL: 497, EUR: 79, USD: 99 },
    annual: { BRL: 4970, EUR: 790, USD: 990 }
  },
  growth: {
    monthly: { BRL: 1497, EUR: 249, USD: 299 },
    annual: { BRL: 14970, EUR: 2490, USD: 2990 }
  },
  premium: {
    monthly: { BRL: 3997, EUR: 699, USD: 849 },
    annual: { BRL: 39970, EUR: 6990, USD: 8490 },
    plus: true
  }
};

export function getDefaultITConsultingCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

export function formatITConsultingPlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getITConsultingPlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: IT_CONSULTING_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatITConsultingPlanPrice
  });
}
